export default {"src":"/_next/static/media/heroPrivacySecurityPd.fd7e4b49.svg","height":20,"width":220,"blurWidth":0,"blurHeight":0};